import { FEATURE_ROLES, Role } from '@tendium/prom-types';
import { COMMON_PAYMENT_ROLES, isRole, PaymentRoles } from './types';
import { useCallback, useMemo } from 'react';
import { ownership } from 'src/models/ownership';

export function useAvailableRoles(options?: {
  excludeNonActivated?: boolean;
}): [string[], string[], (role: Role) => void] {
  const paymentRoles = usePaymentRoles();

  let availablePaymentRoles = useMemo(() => [...paymentRoles, ...COMMON_PAYMENT_ROLES], [paymentRoles]);

  if (options?.excludeNonActivated) availablePaymentRoles = availablePaymentRoles.filter(e => e !== Role.NOT_ACTIVATED);

  const availableRoles = useMemo(() => [...availablePaymentRoles, ...FEATURE_ROLES], [availablePaymentRoles]);

  const isRoleAvailable = useCallback(
    (role: unknown): role is PaymentRoles => {
      return isRole(role) && availableRoles.some(r => r === role);
    },
    [availableRoles]
  );

  return [availableRoles, availablePaymentRoles, isRoleAvailable];
}

export function useFeatureRoles(): string[] {
  return FEATURE_ROLES.sort((role1, role2) => role1.toString().localeCompare(role2.toString()));
}

export function usePaymentRoles(): string[] {
  return useMemo(() => ownership.paymentRoles.roles, []);
}

export function useDefaultPremiumRoles(): Role[] {
  return useMemo(() => ownership.paymentRoles.defaultPremiumRoles, []);
}

export function useDefaultBasicRoles(): Role[] {
  return useMemo(() => ownership.paymentRoles.defaultBasicRoles, []);
}
